import { combineReducers, Action } from "redux";
import { connectRouter } from "connected-react-router";

import { Reducer } from "react";
import { History } from "history";
import { reducer as modalProvider } from "../modules/modalProvider";
import { IStore } from "./types";
import user from "./user/user.reducer";
import loading from "./loading";

export default function createReducer(
  history: History
): Reducer<IStore | undefined, Action> {
  return combineReducers<any, any>({
    router: connectRouter(history),
    modalProvider,
    user,
    loading
  });
}
